<table>
  <ng-content />
</table>
